import React from 'react';
import { Helmet } from 'react-helmet-async';
import AppointmentSettingsClient from '../../components/appointments/AppointmentSettingsClient';

const AppointmentSettingsPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Appointment Settings - Doctif</title>
        <meta name="description" content="Configure working hours and appointment preferences" />
      </Helmet>
      <AppointmentSettingsClient />
    </>
  );
};

export default AppointmentSettingsPage;
